module.exports = __webpack_public_path__ + "media/MRI15B.23a756df.mp3";